import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import { renderLatLngValue } from '../../../../helpers';
import useSite from '../../../../store/hooks/useSite';
import DisplayTextField from '../../../../components/DisplayTextField';
import DisplayKioskCode from '../../../../components/DisplayKioskCode';

export default function SiteInfo() {
  const { id } = useSelector((state) => state.pages.site);
  const site = useSite(id);

  const address = get(site, 'address', '-');
  const lat = renderLatLngValue(get(site, 'location.lat'), '-');
  const lng = renderLatLngValue(get(site, 'location.lng'), '-');
  const zone = get(site, 'timezone.zone', '-');
  const name = get(site, 'timezone.name', '-');
  const offset = get(site, 'timezone.offset', '-');

  return (
    <Card raised>
      <CardContent
        sx={{
          pl: 1,
          pr: 1,
          pt: 0,
          pb: '0 !important',
        }}>
        <List disablePadding>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <ListItemText>
              <DisplayTextField
                label='Address'
                value={address}
                sx={{ width: '60%' }}
                inputProps={{
                  autoComplete: 'off',
                }}
              />
              <DisplayTextField
                label='Latitude'
                value={typeof lat === 'string' ? lat : lat.toFixed(2) + '°'}
                inputProps={{
                  autoComplete: 'off',
                }}
              />
              <DisplayTextField
                label='Longitude'
                value={typeof lng === 'string' ? lng : lng.toFixed(2) + '°'}
                inputProps={{
                  autoComplete: 'off',
                }}
              />
            </ListItemText>
          </ListItem>
          <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
            <ListItemText>
              <DisplayTextField
                label='Location'
                value={zone}
                sx={{ width: '60%' }}
                inputProps={{
                  autoComplete: 'off',
                }}
              />
              <DisplayTextField
                label='Timezone'
                value={name}
                inputProps={{
                  autoComplete: 'off',
                }}
              />
              <DisplayTextField
                label='UTC Offset'
                value={offset}
                InputProps={{
                  readOnly: true,
                  disableUnderline: true,
                }}
                inputProps={{
                  autoComplete: 'off',
                }}
              />
            </ListItemText>
          </ListItem>
          {site?.kiosk_code && (
            <ListItem sx={{ pl: 0, pr: 0, pt: 1, pb: 1 }}>
              <ListItemText>
                <DisplayKioskCode type='site' kioskCode={site.kiosk_code} />
              </ListItemText>
            </ListItem>
          )}
        </List>
      </CardContent>
    </Card>
  );
}
